import { useCallback, useState } from "react";

// Open/close + payload state for one dialog. `target` is deliberately NOT cleared on close, so the
// content doesn't blank out while the dialog fades.
export function useDialogState<T>() {
  const [target, setTarget] = useState<T | null>(null);
  const [open, setOpen] = useState(false);
  const openWith = useCallback((value: T) => {
    setTarget(value);
    setOpen(true);
  }, []);
  return { target, open, setOpen, openWith };
}
